import { LanguageBadge } from 'types/Badge'

const getLanguageName = (language: LanguageBadge) => {
  switch (language) {
    case 'aws':
      return 'AWS'
    case 'c':
      return 'C'
    case 'cpp':
      return 'C++'
    case 'css':
      return 'CSS'
    case 'docker':
      return 'Docker'
    case 'elixir':
      return 'Elixir'
    case 'go':
      return 'Go'
    case 'html':
      return 'HTML'
    case 'java':
      return 'Java'
    case 'javascript':
      return 'JavaScript'
    case 'json':
      return 'JSON'
    case 'markdown':
      return 'Markdown'
    case 'python':
      return 'Python'
    case 'rust':
      return 'Rust'
    case 'shell':
      return 'Shell'
    case 'typescript':
      return 'TypeScript'
    case 'nodejs':
      return 'Node.js'
    case 'mysql':
      return 'MySQL'
    case 'electron':
      return 'Electron'
    case 'nextjs':
      return 'Next.js'
    case 'tailwind':
      return 'Tailwind'
    case 'cf-pages':
      return 'Cloudflare Pages'
    case 'react':
      return 'React'
    case 'graphql':
      return 'GraphQL'
    case 'mongo':
      return 'MongoDB'
    case 'gatsby':
      return 'Gatsby'
    case 'angular':
      return 'Angular'
    case 'android':
      return 'Android'
    case 'postgres':
      return 'PostgreSQL'
    default:
      return 'Unknown'
  }
}

const getLanguageClassnames = (language: LanguageBadge) => {
  switch (language) {
    case 'aws':
      return 'text-amber-900 bg-amber-200'
    case 'c':
      return 'text-rose-900 bg-rose-200'
    case 'cpp':
      return 'text-red-900 bg-red-200'
    case 'css':
      return 'text-cyan-900 bg-cyan-200'
    case 'docker':
      return 'text-blue-900 bg-blue-200'
    case 'elixir':
      return 'text-fuchsia-900 bg-fuchsia-200'
    case 'go':
      return 'text-cyan-900 bg-cyan-200'
    case 'html':
      return 'text-orange-900 bg-orange-200'
    case 'java':
      return 'text-slate-900 bg-slate-200'
    case 'javascript':
      return 'text-yellow-900 bg-yellow-200'
    case 'json':
      return 'text-zinc-900 bg-zinc-200'
    case 'markdown':
      return 'text-neutral-900 bg-neutral-200'
    case 'python':
      return 'text-sky-900 bg-sky-200'
    case 'rust':
      return 'text-gray-900 bg-gray-200'
    case 'shell':
      return 'text-green-900 bg-green-200'
    case 'typescript':
      return 'text-blue-900 bg-blue-200'
    case 'nodejs':
      return 'text-green-900 bg-green-200'
    case 'mysql':
      return 'text-cyan-900 bg-cyan-200'
    case 'electron':
      return 'text-blue-900 bg-blue-200'
    case 'nextjs':
      return 'text-sky-900 bg-sky-200'
    case 'tailwind':
      return 'text-teal-900 bg-teal-200'
    case 'cf-pages':
      return 'text-yellow-900 bg-yellow-200'
    case 'react':
      return 'text-sky-900 bg-sky-200'
    case 'graphql':
      return 'text-pink-900 bg-pink-200'
    case 'mongo':
      return 'text-teal-900 bg-teal-200'
    case 'gatsby':
      return 'text-purple-900 bg-purple-200'
    case 'angular':
      return 'text-rose-900 bg-rose-200'
    case 'android':
      return 'text-lime-900 bg-lime-200'
    case 'postgres':
      return 'text-blue-900 bg-blue-200'
    default:
      return 'text-primary-900 bg-primary-200'
  }
}

const useLanguageBadge = (language: LanguageBadge) => {
  const languageName = getLanguageName(language)
  const languageClassnames = getLanguageClassnames(language)

  return { languageName, languageClassnames }
}

export default useLanguageBadge
